export default {
  path: '/operation-manual',
  path_EN: '/en/operation-manual_EN',
  title: '操作手册',
  title_EN: 'Operation Manual',
  icon: 'mdi-book-open-page-variant',
  access: '操作手册',
  children: [
    {
      title: '操作手册',
      title_EN: 'Operation Manual',
      icon: 'mdi-book-open-variant',
      group: '/manual',
      children: [
        {
          path: '/manual/basic-business-manual',
          name: 'basic-business-manual',
          component: () =>
            import('@/views/operation-manual/basic-business-manual'),
          meta: {
            title: '基础业务',
            title_EN: 'Basic Business Manual',
            access: '基础业务操作手册',
          },
        },
        {
          path: '/manual/crew-system-manual',
          path_EN: '/manual/crew-system-manual_EN',
          name: 'crew-system-manual',
          component: () =>
            import('@/views/operation-manual/crew-system-manual'),
          meta: {
            title: '船员系统',
            title_EN: 'Crew System Manual',
            access: '船员系统操作手册',
          },
        },
        {
          path: '/manual/machinery-management-manual',
          name: 'machinery-management-manual',
          component: () =>
            import('@/views/operation-manual/machinery-management-manual'),
          meta: {
            title: '机务管理',
            access: '机务管理操作手册',
          },
        },
        {
          path: '/manual/maritime-management-manual',
          name: 'maritime-management-manual',
          component: () =>
            import('@/views/operation-manual/maritime-management-manual'),
          meta: {
            title: '海务管理',
            access: '海务管理操作手册',
          },
        },
        {
          path: '/manual/rest-operation-manual',
          name: 'rest-operation-manual',
          component: () =>
            import('@/views/operation-manual/rest-operation-manual'),
          meta: {
            title: '体系运行',
            access: '体系运行操作手册',
          },
        },
        {
          path: '/manual/purchase-management-manual',
          name: 'purchase-management-manual',
          component: () =>
            import('@/views/operation-manual/purchase-management-manual'),
          meta: {
            title: '采购管理',
            access: '采购管理操作手册',
          },
        },
        {
          path: '/manual/expense-management-manual',
          name: 'expense-management-manual',
          component: () =>
            import('@/views/operation-manual/expense-management-manual'),
          meta: {
            title: '费用管理',
            access: '费用管理操作手册',
          },
        },
        {
          path: '/manual/ship-accident-management-manual',
          name: 'ship-accident-management-manual',
          component: () =>
            import('@/views/operation-manual/ship-accident-management-manual'),
          meta: {
            title: '事故管理',
            access: '船舶事故管理操作手册',
          },
        },
        {
          path: '/manual/ship-owner-business-manual',
          name: 'ship-owner-business-manual',
          component: () =>
            import('@/views/operation-manual/ship-owner-business-manual'),
          meta: {
            title: '船东业务',
            access: '船东业务操作手册',
          },
        },
      ],
    },
  ],
}
